import { render, staticRenderFns } from "./HoverPopoverMessageFormatter.vue?vue&type=template&id=53445444&functional=true&"
import script from "./HoverPopoverMessageFormatter.vue?vue&type=script&lang=js&"
export * from "./HoverPopoverMessageFormatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports